module.exports = __webpack_public_path__ + "static/media/thumbs-down.a9f3d2cf.png";